import React, { Component, Fragment } from "react";
import { Modal, ModalHeader,
  ModalBody, Button, ModalFooter } from "reactstrap";
import axios from "axios";
import { API_URL_proyectos } from "../../constants";

import { getAuthHeaders } from "../../utils/auth";
import { IconTrash } from "../ui/icons";
class ConfirmProyectoRemovalModal extends Component {
  state = {
    modal: false,
    errorMessage: ''
  };

  toggle = () => {
    this.setState(previous => ({
      modal: !previous.modal
    }));
  };

  deleteProyecto = pk => {
    const headers = getAuthHeaders();
    // Trailing slash matters: without it Django answered a redirect and the
    // DELETE never reached the server (LSSI: "lo traté de eliminar y no me deja").
    axios.delete(`${API_URL_proyectos}${pk}/`, { headers }).then(() => {
      this.props.resetState();
      this.toggle();
    }).catch((error) => {
      console.error("Error deleting proyecto:", error);
      this.setState({ errorMessage: error.response?.data?.detail || "No se pudo eliminar el proyecto. Intenta de nuevo." });
    });
  };

  render() {
    return (
      <Fragment>
        <Button
          color="danger"
          size="sm"
          onClick={() => this.toggle()}
          data-lssi-action-icon
          aria-label="Remover"
          title="Remover"
        >
          <IconTrash />
          <span className="lssi-action-label"> Remover</span>
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>
            ¿Seguro que deseas borrar el proyecto?
          </ModalHeader>
          {this.state.errorMessage && (
            <ModalBody>
              <div className="text-danger" style={{ fontSize: '0.9rem' }}>{this.state.errorMessage}</div>
            </ModalBody>
          )}

          <ModalFooter>
            <Button type="button" onClick={() => this.toggle()}>
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              onClick={() => this.deleteProyecto(this.props.pk)}
            >
              Si
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default ConfirmProyectoRemovalModal;